import { useStaticQuery, graphql } from 'gatsby'

export const useWordPressAgendas = () => {
  const { allWordpressWpAgenda } = useStaticQuery(
    graphql`
      query {
        allWordpressWpAgenda(sort: { fields: [acf___customdate] }) {
          totalCount
          edges {
            node {
              type
              agenda_category
              title
              slug
              path
              content
              wordpress_id
              acf {
                type
                customdate
                image {
                  source_url
                  title
                }
                gallery {
                  source_url
                  title
                }
              }
            }
          }
        }
      }
    `
  )
  return allWordpressWpAgenda.edges
}
